<template>
  <div class="app-wrapper">
   
    <div>
      <Nav></Nav>
      <div class="main-aside">
        <UserNav></UserNav>
      </div>
      <div class="main-div">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { Nav,Footer,UserNav} from './index'
  export default {
    name: 'UserLayout',
    components: {
      Nav,
      Footer,
			UserNav
    }
  }

</script>
<style lang="scss">
  .main-div{
    margin-left: 230px;
    min-height: 100%;
    -webkit-transition: margin-left 0.28s;
    transition: margin-left 0.28s;
    text-align: left;
    padding-top: 10px;
  }
  .main-aside{
    -webkit-transition: width 0.28s;
    transition: width 0.28s;
    width: 230px;
    height: 100%;
    position: fixed;
    top: 108px;
    bottom: 0;
    left: 0;
    z-index: 1001;
  }

</style>


// WEBPACK FOOTER //
// src/views/layout/userIndex.vue